import React from "react";
import { engagementModels } from "../mock";
import { CheckCircle2, ArrowRight, Clock, Target } from "lucide-react";

const Engagement = () => {
  return (
    <section className="py-24 bg-white dark:bg-[#08132C]">
      <div className="container-x">
        <div className="max-w-3xl reveal">
          <span className="tag-chip">Engagement Models</span>
          <h2 className="section-title mt-4">Choose an engagement that fits your journey</h2>
          <p className="section-sub mt-5">
            From a rapid architecture assessment to fully managed platform engineering, we adapt to where you are on your data journey.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {engagementModels.map((m, i) => (
            <div
              key={m.name}
              className={`reveal relative rounded-2xl p-8 border transition-all hover-lift ${
                i === 1
                  ? "bg-[#0B1B3B] border-[#0B1B3B] text-white"
                  : "bg-white dark:bg-[#0B1B3B] border-slate-200 dark:border-white/10"
              }`}
            >
              {i === 1 && (
                <span className="absolute -top-3 left-8 text-[10px] font-bold tracking-widest bg-[#1E56E3] text-white px-3 py-1 rounded-full">
                  MOST POPULAR
                </span>
              )}
              <div className={`text-xs font-semibold uppercase tracking-wider ${i === 1 ? "text-[#7CA6FF]" : "text-[#1E56E3]"}`}>
                Model 0{i + 1}
              </div>
              <h3 className={`mt-3 text-2xl font-bold ${i === 1 ? "text-white" : "text-[#0B1B3B] dark:text-white"}`}>{m.name}</h3>
              <p className={`mt-4 text-[14px] leading-relaxed ${i === 1 ? "text-slate-300" : "text-slate-600 dark:text-slate-300"}`}>{m.desc}</p>

              <div className="mt-6 space-y-3">
                <div className="flex items-center gap-2 text-sm">
                  <Target size={14} className={i === 1 ? "text-[#7CA6FF]" : "text-[#1E56E3]"} />
                  <span className={i === 1 ? "text-slate-300" : "text-slate-600 dark:text-slate-300"}>Perfect for: <b className={i === 1 ? "text-white" : "text-[#0B1B3B] dark:text-white"}>{m.perfect}</b></span>
                </div>
                <div className="flex items-center gap-2 text-sm">
                  <Clock size={14} className={i === 1 ? "text-[#7CA6FF]" : "text-[#1E56E3]"} />
                  <span className={i === 1 ? "text-slate-300" : "text-slate-600 dark:text-slate-300"}>Duration: <b className={i === 1 ? "text-white" : "text-[#0B1B3B] dark:text-white"}>{m.duration}</b></span>
                </div>
              </div>

              <a
                href="#contact"
                className={`mt-7 inline-flex items-center gap-2 text-sm font-semibold px-5 py-2.5 rounded-full transition-colors ${
                  i === 1
                    ? "bg-[#1E56E3] hover:bg-[#1746BF] text-white"
                    : "border border-[#0B1B3B] text-[#0B1B3B] hover:bg-[#0B1B3B] hover:text-white"
                }`}
              >
                Get Started <ArrowRight size={16} />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Engagement;
